import * as api from '../../api';

export const resetPasswordActions = api.fetchActions('acct', 'fetch-password-reset-token');
export const redeemTokenActions = api.fetchActions('acct', 'redeem-token');

export const actionTypes = {
  ...resetPasswordActions.actionTypes,
  ...redeemTokenActions.actionTypes,
};

export const getResetToken = (token) => api.getThunk(
  `/sessions/${token}`,
  null,
  resetPasswordActions,
  {},
  api.unauthorizedConfig);

export const redeemResetToken = (token, newPassword) => api.postThunk(
  `/sessions/${token}/redeem`,
  { newPassword },
  redeemTokenActions,
  {},
  api.unauthorizedConfig);



// WEBPACK FOOTER //
// src/acct/password/reset-password.actions.js